import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function daysUntil(iso) {
  if (!iso) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(iso + "T00:00:00");
  const diff = Math.round((target - today) / 86400000);
  return diff;
}

export function formatDue(iso) {
  if (!iso) return "—";
  const d = daysUntil(iso);
  if (d === 0) return "Today";
  if (d === 1) return "Tomorrow";
  if (d === -1) return "Yesterday";
  if (d < 0) return `${Math.abs(d)}d overdue`;
  if (d <= 7) return `in ${d}d`;
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export const TYPE_META = {
  task:     { label: "Task",     color: "bg-primary-container text-primary-onContainer",    icon: "check-square" },
  renewal:  { label: "Renewal",  color: "bg-tertiary-container text-tertiary-onContainer",  icon: "refresh-cw" },
  bill:     { label: "Bill",     color: "bg-success-container text-success",                 icon: "dollar-sign" },
  followup: { label: "Follow-up",color: "bg-secondary-container text-secondary-onContainer", icon: "message-circle" },
  doc:      { label: "Doc",      color: "bg-surface-containerHigh text-surface-onVariant",   icon: "file-text" },
};

export const PRIORITY_META = {
  high: { label: "High", color: "bg-danger-container text-danger" },
  med:  { label: "Med",  color: "bg-surface-containerHigh text-surface-onVariant" },
  low:  { label: "Low",  color: "bg-surface-container text-surface-onVariant" },
};

export const STATUS_LABELS = {
  todo: "To do",
  doing: "In progress",
  review: "In review",
  done: "Done",
};
